import React from "react";
import { Stepper, Step, StepLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import { formatDate } from "./TableAddPayments";

const CustomStepper = styled(Stepper)({
  padding: 0, // Remove padding around the stepper
});

const CustomStepLabel = styled(StepLabel)(({ theme }) => ({
  "& .MuiStepLabel-label": {
    color: "#2F2E41", // Cor do texto inativo
    "&.Mui-completed": {
      color: "#2F2E41", // Cor do texto completo
    },
    "&.Mui-active": {
      color: "#2F2E41", // Cor do texto ativo
      fontWeight: "bold", // Negrito no texto ativo
    },
  },
  "& .MuiStepIcon-root": {
    color: "#F2F2F2", // Cor padrão do ícone inativo
    "&.Mui-completed": {
      color: "#F77D05", // Cor do ícone completo
    },
    "&.Mui-active": {
      color: "#F77D05", // Cor do ícone ativo
    },
  },
}));

const CustomStepperComponent = ({ order }) => {
  const statusMap = {
    PEDIDO_FEITO: 0,
    PAGAMENTO_INICIAL: 1,
    EM_PRODUCAO: 2,
    ENVIADO: 3,
    ENTREGUE_PARCIALMENTE: 4,
    ENTREGUE: 5,
  };

  const steps = [
    { label: "Pedido Feito", date: order ? formatDate(order?.createdAt) : "" },
    {
      label: "Pagamento",
      date: order?.paymentUpdateDate
        ? formatDate(order?.paymentUpdateDate)
        : "",
    },
    {
      label: "Em Produção",
      date: order?.inProductionDate ? formatDate(order?.inProductionDate) : "",
    },
    {
      label: "Enviado",
      date: order?.sentDate ? formatDate(order?.sentDate) : "",
    },
    {
      label: "Entregue Parcialmente",
      date: order?.partialDeliveryDate
        ? formatDate(order?.partialDeliveryDate)
        : "",
    },
    {
      label: "Entregue",
      date: order?.deliveredDate ? formatDate(order?.deliveredDate) : "",
    },
  ];

  const [activeStep, setActiveStep] = React.useState(
    order ? statusMap[order.status] : -1
  );

  return (
    <CustomStepper activeStep={activeStep} alternativeLabel>
      {steps.map((step, index) => (
        <Step key={step.label}>
          <CustomStepLabel>
            {step.label}
            <br />
            <span style={{ fontSize: "12px", color: "#888888" }}>
              {step.date}
            </span>
          </CustomStepLabel>
        </Step>
      ))}
    </CustomStepper>
  );
};

export default CustomStepperComponent;
